(() => {
  if (customElements.get('hero-slider')) {
    return;
  }

  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.sliderOptions = {};
    }

    connectedCallback() {
      this.initSlider();
      this.detectFullBled();

      window.addEventListener('load', () => {
        this.detectFullBled();
      });

      window.addEventListener('resize', () => {
        this.detectFullBled();
      });
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.sliderOptions = {
        autoHeight: true,
        calculateHeight: true,
        slidesPerView: 1,
        on: {
          slideChange: () => {
            this.handleSlideChange();
          },
        },
      };

      this.slider = new Swiper(this.querySelector('[data-slider]'), this.sliderOptions);
    }

    handleSlideChange() {
      const that = this;
      const popups = this.querySelectorAll('video-popup');

      setTimeout(function () {
        const videos = that.querySelectorAll('.hero__video video');

        // Pause all videos
        videos.forEach((video) => {
          video.pause();
          video.currentTime = 0;
        });

        // Close popups
        popups.forEach((popup) => {
          const videoPopup = popup.querySelector('.hero__video-popup');
          that.querySelector('video-popup').closeVideo(videoPopup);
        });

        // Play video of the current slide
        const activeSlide = that.querySelector('.swiper-slide-active');
        const activeVideos = activeSlide.querySelectorAll('.hero__video video');

        activeVideos.forEach((activeVideo) => {
          if (activeVideo) {
            activeVideo.play();
          }
        });
      }, 10);
    }

    detectFullBled() {
      if (this.classList.contains('js-slider-container')) {
        const header = document.querySelector('.header-group');
        this.style.marginTop = `${header.offsetHeight}px`
      };
    }
  }

  customElements.define('hero-slider', HeroSlider);
})();
